<template>
  <div>
    <template v-for="(action, index) in actions">
      <v-tooltip
        :key="index"
        top
      >
        <template #activator="tooltip">
          <v-hover
            v-slot="{hover}"
          >
            <v-btn
              text
              icon
              small
              v-bind="tooltip.attrs"
              :class="action.className"
              :color="hover ? action.hoverColor : ''"
              :title="action.title || ''"
              :disabled="false"
              @click="action.isDisable ? undefined : onEmitAction(action)"
              v-on="tooltip.on"
            >
              <v-icon
                :aria-label="action.icon"
                :disabled="action.isDisable"
              >
                {{ `mdi-${action.icon}` }}
              </v-icon>
            </v-btn>
          </v-hover>
        </template>
        <span>{{ action.disabledReason || action.title }}</span>
      </v-tooltip>
    </template>
  </div>
</template>

<script>
export default {
  name: 'TableActions',
  components: {},
  props: {
    actions: { type: Array, default: () => [] }
  },
  methods: {
    onEmitAction(action) {
      this.$emit('action', {
        actionEvent: action.event,
        itemValue: action.item,
        type: action.type
      })
    }
  }
}
</script>
